import React, { useEffect, useState } from 'react';

//Material
import { Box, MenuItem, Paper, Rating, Typography } from '@mui/material';
// import { Stack } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import basePhoto from '../assets/DefaultIMG.png';
import ApiService from '../helpers/apiHelper';
import { dateFormattingByDateDot } from '../helpers/date-helpers';
import '../pages/MainPage/index.css';
import {
  setIsOpenAuthModal,
  setIsOpenComplainModal,
  setIsOpenDeleteAttentionModal,
  setIsOpenDeleteModal,
  setIsOpenResendingModal,
  setIsOpenServiceModal,
  setIsOpenServicePromoteModal,
  setUserSavedServices
} from '../redux/mainReducer';
import CloseIcon from '@mui/icons-material/Close';
import { MoreHoriz } from '@mui/icons-material';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTranslate } from 'react-redux-multilingual';

function ServiceCard({
  index,
  el,
  noWidth = false,
  maxHeight = 'unset',
  isServicePage = false,
  dataSetter,
  ...props
}) {
  const [open, setOpen] = useState(false);

  const handleClick = (event) => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // eslint-disable-next-line
  const translate = useTranslate();
  const params = useParams();
  // const apiActivateId = new ApiService('posts/service/switch-activating');

  const apiSavedService = new ApiService('posts/saved-service');
  const apiDelete = new ApiService(`posts/service`, translate);
  const apiComplaint = new ApiService('auth/user/complaint-user');

  // const apiActivateId = new ApiService('service/switch-activating');

  // const apiSavedService = new ApiService('saved-service');
  // const apiDelete = new ApiService(`service`, translate);
  // const apiComplaint = new ApiService('/user/complaint-user');

  const [photos, setPhotos] = useState([]);
  const userData = useSelector((state) => state.global.userData);
  const userSavedServices = useSelector((state) => state.global.userSavedServices);
  const language = useSelector((state) => state.Intl.locale);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    let mounted = true;

    if (el?.photoUrls && el?.photoUrls.length !== 0 && mounted) {
      setPhotos([...el?.photoUrls]);

      return () => (mounted = false);
    }
    // eslint-disable-next-line
  }, []);
  const deleteService = (id) => {
    apiDelete
      .deleteItem(id)
      .then((res) => {
        dataSetter(true);
        enqueueSnackbar('Товар успішно видалено', { variant: 'success' });
        dispatch(setIsOpenDeleteModal({ isOpen: false, text: '', func: null, id: null }));
      })
      .catch((error) => {
        if (
          error?.message &&
          error?.message === 'You cant delete this service because that have orders'
        ) {
          dispatch(setIsOpenDeleteAttentionModal(true));
        }
      });
  };
  const sendComplaint = (type, text) => {
    apiComplaint
      .updateDataID(userData?.id, {
        complaintType: type,
        complaintDescription: text.length !== 0 ? text : null
      })
      .then((res) => {
        dispatch(setIsOpenComplainModal({ isOpen: false, func: null }));
        enqueueSnackbar('Скаргу надіслано.', { variant: 'success' });
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталась помилка.', { variant: 'error' });
      });
  };
  return (
    <Paper
      {...props}
      key={index}
      sx={{
        opacity:
          window.location.href.includes('user-page') &&
          userData?.id === el?.userDTO?.id &&
          userData?.role !== 'PREMIUM_USER' &&
          !el?.isActive
            ? '0.3'
            : '1',
        textAlign: 'center',
        overflow: 'hidden',
        alignItems: 'center',
        backgroundColor: 'white',
        border: 'none',
        borderRadius: '5px',
        padding: '0',
        maxHeight: { xs: isServicePage ? '369px' : '454px', sm: '350px', md: '394px' },
        minHeight: { xs: isServicePage ? '369px' : '454px', sm: '350px', md: '394px' },
        maxWidth: { xs: isServicePage ? '250px' : '350px', sm: '246px', md: '276px' },
        minWidth: { xs: isServicePage ? '250px' : '350px', sm: '246px', md: '276px' },
        position: 'relative',
        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
        margin: '0 auto'
        // '&:hover':
        //   isHoverMy || isHoverSearch || isHoverSaved
        //     ? {}
        //     : { boxShadow: '-10px 10px 3px black', transform: 'scale(1.025)', transition: 'all 1s' }
      }}
    >
      {window.location.href.includes('search') && el?.isPromoted && (
        <div
          style={{
            position: 'absolute',
            width: 'fit-content',
            backgroundColor: '#E2F2FF',
            padding: '4px 8px',
            borderRadius: '4px',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            fontFamily: 'FixelText-Medium',
            fontWeight: '500',
            color: '#60A5DF',
            fontSize: '16px',
            left: '8px',
            top: '8px'
            // top: '4px',
            // left: '4px'
          }}
        >
          Топчик
        </div>
      )}
      {el?.isBlocked ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: 'calc(100% + 4px)',
            height: 'calc(100% + 4px)',
            position: 'absolute',
            backgroundColor: 'rgba(124, 124, 124, 0.40)',
            top: -1,
            right: -1,
            zIndex: 100
          }}
        >
          <div
            style={{
              // position: 'absolute',
              width: 'fit-content',
              backgroundColor: '#FFE5E5',
              padding: '4px 8px',
              borderRadius: '4px',
              boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#F64D36',
              fontSize: '20px'
              // top: '4px',
              // left: '4px'
            }}
          >
            Заблоковано
          </div>
        </div>
      ) : null}
      {userData?.id && !window.location.href.includes('messages') && (
        <div
          id="positioned-button"
          aria-controls={open ? 'service-positioned-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50px',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            cursor: 'pointer',
            top: '8px',
            right: '8px',
            zIndex: 101
          }}
        >
          <MoreHoriz sx={{ fontSize: '20px' }} />
        </div>
      )}

      <Box
        id="service-positioned-menu"
        aria-labelledby="service-positioned-button"
        sx={{
          display: open ? 'flex' : 'none',
          flexDirection: 'column',
          justifyContent: 'center',
          width: 'calc(100% + 4px)',
          height: 'calc(100% + 4px)',
          position: 'absolute',
          backgroundColor: 'white',
          top: -1,
          right: -1,
          zIndex: 201,
          p: { xs: '12px', sm: '12px', md: '20px' }
        }}
      >
        <Box
          id="positioned-button-close"
          sx={{
            position: 'absolute',
            backgroundColor: 'white',
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50px',
            boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
            cursor: 'pointer',
            top: '8px',
            right: '8px'
          }}
        >
          <CloseIcon onClick={handleClose} />
        </Box>
        {el?.id !== params?.id && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#E2F2FF' },
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              // navigate(`/${language}/service/${el.id}`)*/}
              // if (userData?.id) {
              // navigate(`/${language}/service/${el.id}`);*/}
              window.open(`${window.location.origin}/${language}/service/${el.id}`);
              window.scrollTo({ top: 0 });
              // } else {
              //   dispatch(setIsOpenAuthModal(true));
              // }

              handleClose();
            }}
          >
            Сторінка товару
          </MenuItem>
        )}
        {el?.userDTO?.id === userData?.id && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#E2F2FF' },
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              dispatch(setIsOpenServiceModal({ isOpen: true, data: el, setter: dataSetter }));
            }}
          >
            Редагувати
          </MenuItem>
        )}{' '}
        {el?.userDTO?.id === userData?.id && !el?.isBlocked && (
          <MenuItem
            sx={{
              ':hover': { backgroundColor: '#E2F2FF' },
              borderRadius: '4px',
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              if (userData.role === 'PREMIUM_USER') {
                dispatch(
                  setIsOpenServicePromoteModal({
                    isOpen: true,
                    id: el?.id,
                    title: el?.nameService,
                    setter: dataSetter
                  })
                );
                handleClose();
              } else {
                navigate('/ua/tariffs');
              }
            }}
          >
            Просувати
          </MenuItem>
        )}
        {!el?.isBlocked ? (
          <MenuItem
            sx={{
              ':hover': { backgroundColor: '#E2F2FF' },
              borderRadius: '4px',
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              dispatch(setIsOpenResendingModal({ isOpen: true, id: el.id, type: 'service' }));
            }}
          >
            Відправити у повідомлення
          </MenuItem>
        ) : null}
        <MenuItem
          sx={{
            borderRadius: '4px',
            ':hover': { backgroundColor: '#E2F2FF' },

            fontFamily: 'FixelText-Medium',
            fontWeight: '500',
            pl: '12px !important',
            m: '2px 0px !important'
          }}
          onClick={() => {
            navigator.clipboard.writeText(`${window.location.origin}/ua/service/${el?.id}`);
            handleClose();
            enqueueSnackbar('Посилання на товар скопійовано', { variant: 'success' });
          }}
        >
          Скопіювати посилання
        </MenuItem>
        {el?.isBlocked && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#E2F2FF' },
              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              window.open(`${window.location.origin}/${props?.language}/support`);
              window.scrollTo({ top: 0 });
            }}
          >
            Підтримка
          </MenuItem>
        )}
        {el?.userDTO?.id !== userData?.id && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#FFE5E5' },

              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#F64D36',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              dispatch(
                setIsOpenComplainModal({
                  isOpen: true,
                  func: sendComplaint
                })
              );
            }}
          >
            Поскаржитись
          </MenuItem>
        )}
        {el?.userDTO?.id === userData?.id && (
          <MenuItem
            sx={{
              borderRadius: '4px',
              ':hover': { backgroundColor: '#FFE5E5' },

              fontFamily: 'FixelText-Medium',
              fontWeight: '500',
              color: '#F64D36',
              pl: '12px !important',
              m: '2px 0px !important'
            }}
            onClick={() => {
              handleClose();
              dispatch(
                setIsOpenDeleteModal({
                  isOpen: true,
                  text: 'цей товар?',
                  func: deleteService,
                  id: el?.id
                })
              );
            }}
          >
            Видалити товар
          </MenuItem>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          maxHeight: { xs: isServicePage ? '369px' : '454px', sm: '350px', md: '394px' },
          minHeight: { xs: isServicePage ? '369px' : '454px', sm: '350px', md: '394px' },
          maxWidth: { xs: isServicePage ? '250px' : '350px', sm: '246px', md: '276px' },
          minWidth: { xs: isServicePage ? '250px' : '350px', sm: '246px', md: '276px' }
        }}
      >
        <Box
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            // navigate(`/${language}/service/${el.id}`)*/}
            // if (userData?.id) {
            // navigate(`/${language}/service/${el.id}`);*/}
            window.open(`${window.location.origin}/${language}/service/${el.id}`);
            // } else {
            //   dispatch(setIsOpenAuthModal(true));
            // }
          }}
          sx={{
            minHeight: { xs: isServicePage ? '171px' : '350px', sm: '246px', md: '276px' },
            maxHeight: { xs: isServicePage ? '171px' : '350px', sm: '246px', md: '276px' },
            cursor: 'pointer'
          }}
        >
          {el !== null &&
          el &&
          el?.photoUrls &&
          el?.photoUrls.length !== 0 &&
          el?.photoUrls.length === 1 &&
          photos.length !== 0
            ? photos.map(
                (photo, index) =>
                  index === 0 && (
                    <img
                      key={`photo${index}`}
                      src={photo}
                      alt={`illustration`}
                      style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                    />
                  )
              )
            : null}
          {/* {isLoadingPhotos && (
              <Skeleton
                sx={
                  maxHeight !== 'unset'
                    ? { height: 240, width: 240, margin: '0 auto' }
                    : { height: 370, width: 370, margin: '0 auto' }
                }
                animation="wave"
                variant="rectangular"
              />
            )} */}
          {el !== null &&
            el &&
            el?.photoUrls &&
            el?.photoUrls.length !== 0 &&
            el?.photoUrls.length > 1 &&
            photos.length !== 0 &&
            photos.map(
              (photo, index) =>
                index === 0 && (
                  <img
                    key={`photo${index}`}
                    src={photo}
                    alt={`photo-il`}
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                  />
                )
            )}
          {(el !== null && !el?.photoUrls) ||
          (el !== null && el?.photoUrls && el?.photoUrls.length === 0) ? (
            <img
              src={basePhoto}
              alt="defaultImg"
              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
            />
          ) : null}
        </Box>

        {/* {el!==null&&el &&el?.encodedPhotos&&
          el?.encodedPhotos.length !== 0&&el?.encodedPhotos.length>1 &&  <ImageGallery style={{marginTop:0}} showPlayButton={false} showBullets={false} showFullscreenButton={false} items={el.encodedPhotos.map(photo=>{
            return {
              original:`data:${photo.contentType};base64, ${photo.encodedContent}`,
              thumbnail:`data:${photo.contentType};base64, ${photo.encodedContent}`,
              originalHeight:300,
              thumbnailHeight:65,
            }
           })}/>} */}
        <Box sx={{ display: 'flex', flexDirection: 'column', p: '0px 8px 8px' }}>
          <Typography
            variant="subtitle"
            sx={{
              fontSize: { xs: isServicePage ? '12px' : '16px', sm: '16px' },
              fontFamily: 'FixelText-Regular',
              margin: '0px 0px 8px',
              wordBreak: 'break-word',
              textAlign: 'left',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            {el.nameService}
            {userData && userSavedServices.length !== 0 && userSavedServices.includes(el.id) ? (
              <BookmarkIcon
                onClick={() => {
                  if (userData?.id) {
                    if (!el?.isBlocked) {
                      apiSavedService.deleteItemQuery({ postId: el.id }).then((res) => {
                        // dataSetter();
                        const newArray = userSavedServices.filter((id) => el.id !== id);
                        dispatch(setUserSavedServices([...newArray]));
                      });
                    }
                  } else {
                    dispatch(setIsOpenAuthModal(true));
                  }
                }}
                sx={{
                  zIndex: 200,
                  width: '20px',
                  height: '30px',
                  cursor: 'pointer',
                  color: !el?.isBlocked ? 'rgb(239, 201, 56)' : 'lightgray',
                  ':hover': {
                    color: !el?.isBlocked ? 'rgb(239, 201, 56)' : 'lightgray',
                    cursor: !el?.isBlocked ? 'pointer' : 'default'
                  }
                }}
              />
            ) : (
              <BookmarkBorderOutlinedIcon
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  if (userData?.id) {
                    if (!el?.isBlocked) {
                      apiSavedService.updateDataQueryPost({ serviceId: el.id }).then((res) => {
                        // dataSetter();
                        const newArray = [...userSavedServices, el.id];
                        dispatch(setUserSavedServices([...newArray]));
                      });
                    }
                  } else {
                    dispatch(setIsOpenAuthModal(true));
                  }
                }}
                sx={{
                  zIndex: 200,
                  width: '20px',
                  height: '30px',
                  color: el?.isBlocked && 'lightgray',
                  cursor: !el?.isBlocked ? 'pointer' : 'default',
                  '&:hover': {
                    color: !el?.isBlocked ? '#EFC938' : 'lightgray'
                  }
                }}
              />
            )}
          </Typography>
          <Typography
            style={{
              fontSize: '16px',
              margin: '0px 0px 8px',
              fontFamily: 'FixelText-Medium',
              textAlign: 'left',
              fontWeight: '500'
            }}
          >
            {`${el.price} ${el.currency}`}
          </Typography>
          <Typography
            sx={{
              color: '#868686',
              fontSize: { xs: isServicePage ? '12px' : '14px', sm: '14px' },
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              margin: '0px 0px 8px'
            }}
            variant="subtitle"
          >
            {dateFormattingByDateDot(new Date(el.creationTimeForService))}
            <Typography
              style={{
                fontSize: '16px',
                margin: '0px ',
                fontFamily: 'FixelText-Regular',
                color: '#868686',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              {/* {`${el.price} ${el.currency}`} */}
              {/*{el?.numberFeedbacks !== 0 ? `Відгуки: ${el?.numberFeedbacks}` : null}*/}
              <Rating
                sx={{
                  fontSize: { xs: isServicePage ? '12px' : '18px', sm: '18px' },
                  ml: '10px',
                  mb: '4px'
                }}
                value={el.rating}
                precision={0.5}
                readOnly
              />
            </Typography>
          </Typography>
        </Box>
      </Box>
      {/*{(userData && userData?.role === 'PREMIUM_USER' && el?.isActive) ||*/}
      {/*(userData && userData?.role === 'USER' && el?.isActive) ||*/}
      {/*(userData && userData?.role === 'ADMIN' && el?.isActive) ||*/}
      {/*(userData && userData?.role === 'SUPER_ADMIN' && el?.isActive) ? (*/}
      {/*  <LetsGoBtn*/}
      {/*    className="service-card-btn"*/}
      {/*    width="200px"*/}
      {/*    margin="10px auto"*/}
      {/*    text="Детальніше"*/}
      {/*    onClick={() => {*/}
      {/*      // navigate(`/${language}/service/${el.id}`)*/}
      {/*      if (userData?.id) {*/}
      {/*        // navigate(`/${language}/service/${el.id}`);*/}
      {/*        window.open(`${window.location.origin}/${language}/service/${el.id}`);*/}
      {/*        window.scrollTo({ top: 0 });*/}
      {/*      } else {*/}
      {/*        dispatch(setIsOpenAuthModal(true));*/}
      {/*      }*/}
      {/*    }}*/}
      {/*  />*/}
      {/*) : null}*/}
      {/*{window.location.href.includes('search') ||*/}
      {/*window.location.href.includes('ribbon') ||*/}
      {/*window.location.href.includes('saved') ? (*/}
      {/*  <LetsGoBtn*/}
      {/*    className="service-card-btn"*/}
      {/*    width="200px"*/}
      {/*    margin="10px auto"*/}
      {/*    text="Детальніше"*/}
      {/*    onClick={() => {*/}
      {/*      // navigate(`/${language}/service/${el.id}`)*/}
      {/*      if (userData?.id) {*/}
      {/*        // navigate(`/${language}/service/${el.id}`);*/}
      {/*        window.open(`${window.location.origin}/${language}/service/${el.id}`);*/}
      {/*        window.scrollTo({ top: 0 });*/}
      {/*      } else {*/}
      {/*        dispatch(setIsOpenAuthModal(true));*/}
      {/*      }*/}
      {/*    }}*/}
      {/*  />*/}
      {/*) : null}*/}
      {/*{window.location.href.includes('user-page') && !el?.isActive ? (*/}
      {/*  <LetsGoBtn2*/}
      {/*    className="service-card-btn"*/}
      {/*    disabled={userData?.role !== 'PREMIUM_USER' ? true : false}*/}
      {/*    width="120px"*/}
      {/*    margin="10px auto 10px !important"*/}
      {/*    text="Активувати"*/}
      {/*    onClick={() => {*/}
      {/*      apiActivateId*/}
      {/*        .updateDataQuery({ serviceId: el?.id, isActive: true })*/}
      {/*        .then((res) => {*/}
      {/*          dataSetter(true);*/}
      {/*        })*/}
      {/*        .catch((error) => {*/}
      {/*          console.error(error);*/}
      {/*          enqueueSnackbar('Послугу не активовано!', { variant: 'error' });*/}
      {/*        });*/}
      {/*    }}*/}
      {/*  />*/}
      {/*) : null}*/}
    </Paper>
  );
}
// const mapStateToProps = (state) => {
//   return {
//     language: state.Intl.locale
//   };
// };
export default ServiceCard;
